import React from "react"
import "./Checkboxes.css"

export default function Checkboxes(params) {

    const {values, selected, onChange} = params
    
    
    const onClick = (event) => {
        const list = !selected ? [] : [...selected]
        const value = event.target.name
        const index = list.indexOf(value)
        if (index !== -1) {
            list.splice(index, 1)
        }
        else {
            list.push(value)
        }
        onChange(list)
    }
    
    return <div className="checkboxes">
        {values?.map(value => <label key={value} className="gss-checkbox">
            <input type="checkbox" name={value} checked={selected?.includes(value) || false} onChange={onClick}/>
            <span className="btn btn-primary btn-sm">{value}</span>
        </label>)}
    </div>
}